import { VrEvent } from './VrEvent';

export class AssetEvent extends VrEvent{
    public sceneAssetRelationId: number;
}